import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { UserRoleSchema } from "../../Schemas/UserRole";

interface Filter extends IFilterSchema {
  column: AclRolesListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: AclRolesListColumnSortable;
}

export enum AclRolesListColumnFilterable {
  ID = "id",
  WORKSPACE_ID = "workspace_id",
  ACL_ROLE_ID = "acl_role_id",
  USER_ID = "user_id",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
}
export enum AclRolesListColumnSortable {
  ID = "id",
  WORKSPACE_ID = "workspace_id",
  ACL_ROLE_ID = "acl_role_id",
  USER_ID = "user_id",
  CREATED_AT = "created_at",
  UPDATED_AT = "updated_at",
}

interface ICreateAclRoleUserPayload {
  workspace_id: null | number;
  acl_role_id: number;
  user_id: number;
}

export interface AclRoleUserListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface AclRolesUserListResponseBody extends IResponseBody {
  data: {
    acl_role_users: UserRoleSchema[];
    total: number;
  };
}
export interface AclRoleUserCreateResponseBody extends IResponseBody {
  data: {
    acl_role_user: UserRoleSchema;
  };
}

export interface RolesDetailResponseBody extends IResponseBody {
  data: {
    acl_role_user: UserRoleSchema;
  };
}

export class AclRoleUsersListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/acl-role-users`;
  }

  async list(
    queryStrings?: AclRoleUserListQueryString
  ): Promise<AclRolesUserListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async create(
    payload: ICreateAclRoleUserPayload
  ): Promise<AclRoleUserCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/create`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async update(
    roleId: string,
    payload: ICreateAclRoleUserPayload
  ): Promise<AclRoleUserCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/update`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
  async delete(roleId: string): Promise<AclRoleUserCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/delete`,
        {}
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
